<template>
  <div class="bk bk-comment" @click="$emit('clickComment')">
    <h3>
      {{ user?.label }}
    </h3>
    <RelativeTime v-slot="{ formatted }" :timestamp="timestamp">
      <div class="bk-comment-date">
        {{ formatted }}
      </div>
    </RelativeTime>
    <div class="bk-comment-body" v-html="body" />
    <button
      v-if="!resolved && resolveImplemeted"
      @click.capture.stop="$emit('resolve')"
    >
      <Icon name="check" />
      <span>{{ $t("commentsMarkAsResolved", "Resolve") }}</span>
    </button>
  </div>
</template>

<script setup>
import { computed, useBlokkli } from "#imports";
import { Icon, RelativeTime } from "#blokkli/components";
const { adapter, $t } = useBlokkli();
const resolveImplemeted = computed(() => !!adapter.resolveComment);
defineEmits(["resolve", "clickComment"]);
const props = defineProps({
  uuid: { type: [String, Number], required: false },
  blockUuids: { type: Array, required: false },
  resolved: { type: Boolean, required: false },
  body: { type: String, required: false },
  created: { type: [String, Number], required: false },
  user: { type: Object, required: false }
});
const timestamp = computed(
  () => props.created ? Number.parseInt(props.created.toString()) : 0
);
</script>

<script>
export default {
  name: "Comment"
};
</script>
